// Free Lead Types - matching the constants from plugins/Api/src/Model/Table/FreeLeadsTable.php.
// The full list of types lives in the `free_lead_types` DB table (editable in
// /settings/free-lead-types), so `free_lead_type` is an open string; these constants
// only cover values the frontend needs to reference directly.
export const FREE_LEAD_TYPE_INCREASE_LIMIT_PROMO = 'increase_limit_promo'
export const FREE_LEAD_TYPE_PREMIUM_OB_FREE_LEADS = 'premium_ob_free_leads'
export const FREE_LEAD_TYPE_FREE_TRIAL = 'free_trial'
export const FREE_LEAD_TYPE_BAF_INVITEE = 'baf_invitee'
export const FREE_LEAD_TYPE_BAF_INVITER = 'baf_inviter'
export const FREE_LEAD_TYPE_TRIAL_VALIDATION = 'trial_validation'
export const FREE_LEAD_TYPE_BULK_GIVEAWAY = 'bulk_giveaway'
export const FREE_LEAD_TYPE_SUBSCRIPTION_PROMO = 'subscription_promo'
export const FREE_LEAD_TYPE_SUBSCRIPTION_PROMO_ONE_TIME = 'subscription_promo_one_time_leads'
export const FREE_LEAD_TYPE_PAUSE_RETENTION = 'pause_retention'
export const FREE_LEAD_TYPE_WINBACK = 'winback'
export const FREE_LEAD_TYPE_RECLAIM_RESTORE = 'reclaim_restore'

// Interface for creating new free leads
export interface CreateFreeLeadData {
    service_provider_id: number
    nr_leads: number
    comment: string
    free_lead_type: string
    expiration?: string | null
    after_payed?: boolean
    enable_after_nr_leads_payed?: number
}

/** Row of the free_lead_types lookup table. @see FreeLeadTypesController */
export interface FreeLeadTypeOption {
    free_lead_type_id: number
    value: string
    label: string
    is_manual: boolean
    requires_comment: boolean
    active: boolean
}

// Interface for free lead statistics
export interface FreeLeadStats {
    nrTotal: number
    nrLeft: number
}
